import { render, staticRenderFns } from "./CompanyNews.vue?vue&type=template&id=d2e5e0ac&scoped=true"
import script from "./CompanyNews.vue?vue&type=script&lang=js"
export * from "./CompanyNews.vue?vue&type=script&lang=js"
import style0 from "./CompanyNews.vue?vue&type=style&index=0&id=d2e5e0ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e5e0ac",
  null
  
)

export default component.exports